import { HIDE_MODAL, SHOW_MODAL } from './actions';

export default (state, action) => {
  if (!state) {
    return {
      current: undefined,
    };
  }
  switch (action.type) {
    case HIDE_MODAL:
    case SHOW_MODAL: {
      const { modal } = action;
      return {
        ...state,
        current: modal || undefined,
      };
    }
    default:
      break;
  }
  return state;
};
